<fin-loyalty-view [pageTitle]="pageTitle$ | async">
  <div *ngIf="iframeUrl$ | async as iframeUrl">
    <iframe
      [title]="pageTitle$ | async"
      [attr.src]="iframeUrl$ | async | finSafe: 'resource'"
      width="100%"
      height="800"
      frameborder="0"
      sandbox="allow-top-navigation allow-scripts allow-same-origin allow-forms"
    ></iframe>
  </div>
</fin-loyalty-view>

<fin-cms-json-content
  class="grid-col-12 grid-max-width no-row-gap"
  [template$]="template$"
  [showSideTitle$]="showSideTitle$"
  [pageViewType$]="pageViewType$"
></fin-cms-json-content>
